// Constants
import { AMPLITUDE_SESSION_TIMEOUT } from './amplitudeSessionConstants';

let backgroundedAt: number | null = null;
let unsubscribeLifecycleTracking: (() => void) | undefined;

/**
 * Starts a new Amplitude session when Electron returns after the configured inactivity period.
 */
export const initialiseElectronAmplitudeLifecycleTracking = (
    resetAmplitudeSession: () => void,
): (() => void) | undefined => {
    if (unsubscribeLifecycleTracking) return unsubscribeLifecycleTracking;

    const unsubscribe = window.desktopIntegration?.onLifecycleStateChange?.(({ state, occurredAt }) => {
        if (state === 'background') {
            backgroundedAt = occurredAt;
            return;
        }

        if (!backgroundedAt || occurredAt - backgroundedAt < AMPLITUDE_SESSION_TIMEOUT) {
            backgroundedAt = null;
            return;
        }

        backgroundedAt = null;

        resetAmplitudeSession();
    });

    if (!unsubscribe) return unsubscribe;

    const unsubscribeLifecycleTrackingCallback = () => {
        try {
            unsubscribe();
        } finally {
            if (unsubscribeLifecycleTracking === unsubscribeLifecycleTrackingCallback) {
                backgroundedAt = null;
                unsubscribeLifecycleTracking = undefined;
            }
        }
    };

    unsubscribeLifecycleTracking = unsubscribeLifecycleTrackingCallback;

    return unsubscribeLifecycleTracking;
};
